module.exports = __webpack_public_path__ + "img/status_success_01.9298db62.png";